import { SxProps, Theme } from "@mui/material/styles";

const styles: Record<string, SxProps<Theme>> = {
  wrapper: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "4px",
    backgroundColor: "#F0F9F4",
    border: "1px solid",
    borderImageSource: "linear-gradient(182.35deg, rgba(86, 170, 130, 0.06) 32.88%, rgba(86, 170, 130, 0.2) 142.08%)",
    boxShadow: "0px -1px 0px 0px #56AA8226 inset, 0px 4px 4px 0px #FFFFFF40 inset",
    color: theme => theme.palette.primary.main,
    borderRadius: "8px",
    width: "fit-content",
    padding: "4px 8px",
  },
  dot: {
    width: "6px",
    height: "6px",
    backgroundColor: theme => theme.palette.primary.main,
    borderRadius: "50%",
    margin: "5px",
    boxSizing: "border-box",
  },
};

export default styles;
